<template>
  <div>
    <div class="text-center container mt-5">
      <i class="material-icons border-2 full-icon rounded-circle align-middle mb-4">
        flag
      </i>
      <p class="h5 text-muted mb-3">
        You haven't created goals for your skills yet.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('user', ['getChildSelectedName']),
  },
};
</script>
<style>
.border-2 {
  background-color: #f2f2f2;
  border: 1px solid #cccccc;
  color: #999999;
  font-size: 1.2em !important;
  padding: 0.1em !important;
}
.full-icon {
  font-size: 8em !important;
  color: #e6e6e6;
}
</style>
